import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/icon-eoi-checked.png'


const _hoisted_1 = { class: "eoi-header" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "subtitle-main" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "filters" }
const _hoisted_7 = { class: "dropdown-button" }
const _hoisted_8 = {
  key: 0,
  class: "item-filter-double-wr"
}
const _hoisted_9 = {
  key: 1,
  class: "item-filter"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "spinner"
}
const _hoisted_12 = {
  key: 1,
  class: "empty-block--wrapper"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "table-scroll" }
const _hoisted_16 = { class: "table-header" }
const _hoisted_17 = { class: "eoi-table-scroll scroll-wrapper" }
const _hoisted_18 = { class: "table-default" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "first-td" }
const _hoisted_21 = { class: "bold text-highlighted" }
const _hoisted_22 = { class: "buyers-data" }
const _hoisted_23 = { class: "buyer" }
const _hoisted_24 = {
  key: 0,
  class: "buyer"
}
const _hoisted_25 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "title-main" }, "Contract Forms", -1)),
          _createElementVNode("h3", _hoisted_4, _toDisplayString($setup.plural($setup.counter, "Request")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "button default edit-eoi",
            to: { name: 'EOIEditForm' }
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Edit Form", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "button default primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.editInitialDepositModal = true))
          }, "Edit Initial Deposit")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createVNode($setup["DropDown"], { class: "dropdown dropdown--status" }, {
            control: _withCtx(() => [
              _createElementVNode("button", _hoisted_7, [
                _cache[7] || (_cache[7] = _createElementVNode("p", null, "Status is", -1)),
                ($setup.activeFilter.label === $setup.EoiStatusFilterLabel.PENDING_OR_APPROVED)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("div", { class: "item-filter" }, "Pending", -1),
                      _createElementVNode("p", null, "or", -1),
                      _createElementVNode("div", { class: "item-filter" }, "Approved", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.activeFilter.label), 1))
              ])
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    onClick: ($event: any) => ($setup.changeFilter(item)),
                    class: _normalizeClass({ 'dropdown__item-active': $setup.activeFilter.label === item.label })
                  }, _toDisplayString(item.label), 11, _hoisted_10))
                }), 256))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11))
        : ($setup.lots && $setup.lots.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("img", {
                class: "empty-block--icon",
                src: require('@/assets/icons/star-slim.svg')
              }, null, 8, _hoisted_13),
              _cache[8] || (_cache[8] = _createElementVNode("p", null, _toDisplayString(`Contract Forms will appear here`), -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString($setup.plural($setup.counter, `${$setup.activeFilter.label} Contract Form`)), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("table", _hoisted_18, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableHeaders, (header, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: index,
                            class: _normalizeClass(`column--${$setup.toKebabCase(header)}`)
                          }, _toDisplayString(header), 3))
                        }), 128))
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lots, (item, index) => {
                      return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.eois, (row, idx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "cursor-pointer",
                            key: idx,
                            onClick: ($event: any) => ($setup.onRow(row, item))
                          }, [
                            _createElementVNode("td", _hoisted_20, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["bordered", $setup.getEoiStatusClass(row.status as EoiStatus)])
                              }, null, 2),
                              _cache[9] || (_cache[9] = _createElementVNode("img", {
                                class: "icon-eoi-checked",
                                src: _imports_0
                              }, null, -1))
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", _hoisted_21, "Lot " + _toDisplayString(item?.lot?.title), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item?.lot?.streetName || '--'), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(row.buyersData?.firstBuyer?.firstName) + " " + _toDisplayString(row.buyersData?.firstBuyer?.lastName), 1),
                                (row.buyersData?.secondBuyer?.firstName || row.buyersData?.secondBuyer?.lastName)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(`, ${row.buyersData?.secondBuyer?.firstName}`) + " " + _toDisplayString(row.buyersData?.secondBuyer?.lastName), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(row.buyersData?.firstBuyer?.email), 1),
                            _createElementVNode("td", null, _toDisplayString(row?.buyersData?.firstBuyer?.phone || "-"), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.formatDate(row?.createdAt)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["badge status capitalize", $setup.getEoiStatusClass(row.status)])
                              }, _toDisplayString(row.status), 3)
                            ]),
                            ($setup.estateHasCollaborators)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(row?.business?.name || "-"), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_19))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
    ]),
    ($setup.editInitialDepositModal)
      ? (_openBlock(), _createBlock($setup["EditInitialDepositModal"], {
          key: 0,
          isOpen: $setup.editInitialDepositModal,
          onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.editInitialDepositModal = false))
        }, null, 8, ["isOpen"]))
      : _createCommentVNode("", true),
    ($setup.openCompletedResForm)
      ? (_openBlock(), _createBlock($setup["CompletedResForm"], {
          key: 1,
          "is-open": $setup.openCompletedResForm,
          onClose: $setup.closeCompletedResForm,
          onShare: _cache[2] || (_cache[2] = ($event: any) => ($setup.openSendEoiDocumentsModal = true)),
          eoiId: $setup.eoiId
        }, null, 8, ["is-open", "eoiId"]))
      : _createCommentVNode("", true),
    ($setup.openSendEoiDocumentsModal)
      ? (_openBlock(), _createBlock($setup["SendEoiDocumentsModal"], {
          key: 2,
          "is-open": $setup.openSendEoiDocumentsModal,
          onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.openSendEoiDocumentsModal = false)),
          eoiId: $setup.eoiId
        }, null, 8, ["is-open", "eoiId"]))
      : _createCommentVNode("", true)
  ], 64))
}